import { queryOptions } from "@tanstack/react-query";
import { apiUrl } from "@/lib/api-url";
import { apiGet } from "@/lib/api-error";

export interface PublicGroupCycle {
  id: string;
  name: string;
  description: string;
  price: number;
  maxParticipants: number;
  durationMinutes: number;
  sessionCount: number;
  firstSessionAt: string | null;
  remainingSeats: number;
  therapist: {
    id: string;
    name: string;
    profileImageUrl: string | null;
  };
}

/** Prefiks svih SSR-zavisnosti javne liste; dehydrate-public ga pušta u __SSR__. */
export const publicGroupTherapiesListKey = ["group-therapies", "list"] as const;

/**
 * Javna lista ciklusa grupne terapije (/grupne-terapije). Ključ počinje sa
 * publicGroupTherapiesListKey, pa SSR prefetch ide u __SSR__ i bilježi se kao
 * zavisnost keširanog HTML-a. Write putevi ga obaraju kroz
 * invalidateGroupTherapyPublicCaches (src/api/group-therapies/cycle-cancel.ts).
 */
export const publicGroupTherapiesQuery = queryOptions({
  queryKey: [...publicGroupTherapiesListKey, "public"] as const,
  queryFn: () =>
    apiGet<{ cycles: PublicGroupCycle[] }>(
      apiUrl("/api/group-therapies"),
      "Greška pri učitavanju grupnih terapija",
    ),
});

/**
 * SSR-keš zavisnost detail stranice ciklusa (src/ssr/group-therapy-meta.ts).
 * Ta stranica ne ide kroz React SSR, pa ključ ne mora odgovarati klijentskom
 * useQuery ključu; služi samo da write putevi nađu keširani HTML.
 */
export function groupTherapyDetailSsrKey(id: string): readonly unknown[] {
  return ["group-therapies", "detail", id];
}
